// @ts-strict-ignore
import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { InputNumberModule } from "primeng/inputnumber";
import { InputTextModule } from "primeng/inputtext";
import { TableModule } from "primeng/table";
import { ErrorCheck } from "src/app/shared/models/error-check.model";
import { SharedDirectivesModule } from "src/app/shared/shared-directives.module";
import { ErrorMessageComponent } from "src/app/modules/esim/shared/components/error-message/error-message.component";
import * as C from "../../../../../../shared/constants/globals.constants";
import { EWizDynamicBaseClassComponent } from "src/app/modules/esim/shared/classes/ewiz-dynamic.class";
import { DataService } from "src/app/shared/services/data.service";
import * as ProfileModel from "src/app/shared/models/profile.model";
import { GuidanceBoxComponent } from "src/app/modules/esim/shared/components/guidance-box/guidance-box.component";

@Component({
  selector: C.EWIZ_NETWORK_PLMN_INFORMATION,
  templateUrl: "./network-plmn-information.component.html",
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    InputNumberModule,
    InputTextModule,
    TableModule,
    SharedDirectivesModule,
    ErrorMessageComponent,
    GuidanceBoxComponent
  ]
})
export class EWizNetworkPLMNInformationComponent extends EWizDynamicBaseClassComponent implements OnInit, ErrorCheck {
  constructor(private dataService: DataService) {
    super();
  }

  ngOnInit() {
    this.profileValues.plmnInformationVisited = true;
    this.handleFormEvents();

    this.errorCheck(this.profileValues, this.dataService);
  }

  errorCheck(values: ProfileModel.ProfileDto, dataService: DataService) {
    // Always reset error values to default state prior to executing check
    this.errorFound = false;
    this.errorMessage = "";

    for (const plmnInformation of values.plmnInformation) {
      if (!dataService.isNullOrEmpty(plmnInformation.mobileCountryCode) && plmnInformation.mobileCountryCode.length < 3) {
        this.errorMessage = $localize`Mobile Country Codes must be 3 digits in length`;
        this.errorFound = true;
      } else if (!dataService.isNullOrEmpty(plmnInformation.mobileNetworkCode) && plmnInformation.mobileNetworkCode.length < 2) {
        this.errorMessage = $localize`Mobile Network Codes must be 2 or 3 digits in length`;
        this.errorFound = true;
      } else if (!dataService.isNullOrEmpty(plmnInformation.pnnRecordId) && !dataService.valueInRange(plmnInformation.pnnRecordId, 1, 10)) {
        this.errorMessage = $localize`PNN Record ID values must be between 1 and 10`;
        this.errorFound = true;
      } else if (
        (!dataService.isNullOrEmpty(plmnInformation.mobileCountryCode) ||
          !dataService.isNullOrEmpty(plmnInformation.mobileNetworkCode) ||
          !dataService.isNullOrEmpty(plmnInformation.pnnRecordId)) &&
        (dataService.isNullOrEmpty(plmnInformation.mobileCountryCode) ||
          dataService.isNullOrEmpty(plmnInformation.mobileNetworkCode) ||
          dataService.isNullOrEmpty(plmnInformation.pnnRecordId))
      ) {
        this.errorMessage = $localize`All values must be entered for rows containing any inputs.`;
        this.errorFound = true;
      }
    }

    return this.errorFound;
  }
}
